// extracted by mini-css-extract-plugin
export default {"file-preview-wrapper":"file-preview-wrapper--plvJp","file-preview":"file-preview--q6I20","filename":"filename--rYvgJ"};